module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"product_name":{"label":"Product name","placeholder":"Write product name here"},"price":{"label":"Price","placeholder":"0"},"product_image":{"label":"Product image"}},"id":{"product_name":{"label":"Nama Produk","placeholder":"Tulis nama produk di sini"},"price":{"label":"Harga","placeholder":"0"},"product_image":{"label":"Foto Produk"}}}')
  delete Component.options._Ctor
}
